<template>
  <div class="table" ref="screenshotElement">
    <div class="biaotou" style="-webkit-print-color-adjust: exact">
      <div class="biaotous" style="width: 7%;" >序号</div>
      <div class="biaotous ml5" style="width: 56%">高校专业</div>
      <div
        class="biaotous ml5"
        style="width: 33%; background: none; flex-direction: column">
        <div class="biaotou01">历史等效数据</div>
        <div class="biaotou02">
          <div class="b01 bb">预测{{ form.ming_year || "--" }}</div>
          <div class="b02 bb">{{ form.current_year || "--" }}</div>
          <div class="b02 bb">{{ form.qu_year || "--" }}</div>
          <div class="b02 bb">{{ form.qian_year || "--" }}</div>
        </div>
      </div>
    </div>
    <div
      class="tables"
      style="-webkit-print-color-adjust: exact"
      v-for="(item, i) in lists"
      :key="i">
      <div
        class="biaotous bgn"
        style="
          width: 7%;
          height: 98px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
        "
        v-if="activeName != 3">
        <span>{{ i + 1 }}</span>
      </div>
      <div class="biaotous bgn" style="justify-content: flex-start; width: 56%">
        <div class="text-truncate">
          <div class="d-inline-block" style="display: flex">
            <div class="text-danger text-decoration-none">
              <span
                style="font-size: 160%; cursor: pointer" class="color000"
                @click="collegeClick(item)">
                {{ item.collegeName }}
                <span v-if="item.collegeNameRemark">
                  {{ item.collegeNameRemark }}
                </span>
                [{{ item.collegeNature }}]
              </span>
            </div>
            <span class="text-muted mr-3 color000">
              <span v-if="item.collegeProvince">
                {{ item.collegeProvince }}
              </span>
              <span v-if="item.collegeCity">,{{ item.collegeCity }}</span>
            </span>
          </div>
          <div style="margin-top: 5px">
            <el-tag
              size="mini"
              type="danger"
              style="margin-left: 5px"
              v-if="item.two_yiliu == '是'">
              双一流
            </el-tag>
            <el-tag
              size="mini"
              type="danger"
              style="margin-left: 5px"
              v-if="item.is211 == '是'">
              211
            </el-tag>
            <el-tag
              size="mini"
              type="danger"
              style="margin-left: 5px"
              v-if="item.is985 == '是'">
              985
            </el-tag>
            <el-tag size="mini" style="margin-left: 5px">
              {{ item.collegeNature }}
            </el-tag>
            <el-tag size="mini" type="danger" style="margin-left: 5px">
              {{ item.collegeType }}
            </el-tag>
            <el-tag
              size="mini"
              type="warning"
              class="item"
              v-if="item.shuoshiNum">
              硕
            </el-tag>
            <el-tag
              size="mini"
              type="danger"
              class="item"
              v-if="item.boshiNum">
              博
            </el-tag>
            <el-tag
              size="mini"
              type="success"
              class="item"
              v-if="item.isBao == 1">
              保
            </el-tag>
          </div>
          <div class="text-dark" style="font-size: 14px; margin-top: 4px">
            <span
              class="d-inline-block text-truncate w-100 might-overflow"
              style="display: flex; align-items: center">
              <div
                class="text-primary text-decoration-none color000"
                style="display: flex; align-items: center; cursor: pointer"
                @click="majorDetail(item)">
                {{ item.specialty_title }}
                <span v-if="item.major_field" class="color000">{{ item.major_field }}</span>
                <el-tag
                  size="mini"
                  type="danger"
                  style="margin-left: 5px" class="color000"
                  v-if="
                    item.tese_major_lei &&
                    item.tese_major_lei.includes(item.majors) &&
                    userinfo.isZeng != 1
                  ">
                  国家特色专业
                </el-tag>
                <el-tag
                  size="mini"
                  type="success"
                  style="margin-left: 5px" class="color000"
                  v-if="
                    item.tw0_jianshe_lei &&
                    item.tw0_jianshe_lei.includes(item.majors) &&
                    userinfo.isZeng != 1
                  ">
                  双一流建设学科
                </el-tag>
              </div>
              <span style="margin-left: 15px" class="color000">
                学制：{{ item.schooling_length }},学费：{{
                  item.tuition_fee == -1 ? "待定" : item.tuition_fee
                }}
              </span>
            </span>
          </div>
          <div
            style="margin-top: 4px; font-size: 12px"
            class="d-inline-block text-truncate w-100 might-overflow color000">
            学校代码：{{ item.code }};专业代码：{{ item.specialty_code }};
            <span style="margin-left: 10px" v-if="item.the_second">
              科目要求：{{ item.the_second }}
            </span>
            <span v-if="item.major_field">
              专业方向：{{ item.major_field }}
            </span>
          </div>
          <!-- <div
            style="margin-top: 4px; font-size: 12px"
            class="d-inline-block text-truncate w-100 might-overflow color000">
            
            
          </div> -->
          <div
            style="margin-top: 4px; font-size: 12px;    white-space: normal;" v-if="item.major_remark"
            class="d-inline-block text-truncate w-100 might-overflow">
            专业简介：{{ item.major_remark }};
          </div>

        </div>
      </div>
      <!-- <div class="biaotous bgn" v-if="activeName!=3" style="width: 69.4px;flex-direction: column;align-items: flex-start;margin-left: 10px;">

			<div>高校：{{item.ruan_pai}}</div>
			<div style="margin-top: 10px;">专业：{{majorReturn(item)}}</div>
			</div> -->
      <!-- <div class="biaotous bgn" style="flex-direction: column;" :style="{width:activeName==3?'175px':'157px'}">
			   <el-tag size="small" type="danger">{{item.the_second}}</el-tag>
			</div> -->
      <div
        class="biaotous bgn"
        style="
          width: 33%;
          margin-left: auto;
          background: none;
          flex-direction: column;
          justify-content: flex-start;
        ">
        <div class="xian">
          <div class="b01 bb">
            <el-tooltip
              class="item"
              effect="dark"
              content="招生计划"
              placement="top">
              <img src="@/assets/yuce01.png" class="yuce" alt="" />
            </el-tooltip>

            <span style="margin-left: auto">
              {{ item.planned_number || "-" }}
            </span>
          </div>
          <div class="b02 bb" style="justify-content: flex-end">
            {{ item.current_jihua || "-" }}
          </div>
          <div class="b02 bb" style="justify-content: flex-end">
            {{ item.qu_jihua || "-" }}
          </div>
          <div class="b02 bb" style="justify-content: flex-end">
            {{ item.qian_jihua || "-" }}
          </div>
        </div>
        <div class="xian">
          <div class="b01 bb">
            <el-tooltip
              class="item"
              effect="dark"
              content="分数线"
              placement="top">
              <img src="@/assets/yuce02.png" class="yuce" alt="" />
            </el-tooltip>
            <!--这里需要判断的算法还是直接展示分数-->
            <span
              v-if="item.collegeLevel == '本科'"
              style="margin-left: auto; color: #000">
              <span
                style="margin-left: auto; color:  #000"
                v-if="form.yugu_zhanshi == 1">
                {{ item.yugu_score }}
              </span>
              <span
                style="margin-left: auto; color:  #000"
                v-if="form.yugu_zhanshi == 2">
                {{ item.yugu_score || "-" }}
              </span>
            </span>
            <span
              v-if="item.collegeLevel == '专科'"
              style="margin-left: auto; color:  #000">
              <span
                style="margin-left: auto; color:  #000"
                v-if="form.yugu_zhuanke == 1">
                {{ item.yugu_score }}
              </span>
              <span
                style="margin-left: auto; color:  #000"
                v-if="form.yugu_zhuanke == 2">
                {{ item.yugu_score || "-" }}
              </span>
            </span>
          </div>
          <div class="b02 bb" style="justify-content: flex-end">
            <span style="color:  #000">
              {{ item.current_year_red_score || "-" }}
            </span>
            ({{ item.current_year_min_score || "-" }})
          </div>
          <!--修改-->
          <div class="b02 bb" style="justify-content: flex-end">
            <span style="color:  #000">{{ item.qu_year_red_score || "-" }}</span>
            ({{ item.qu_year_min_score || "-" }})
          </div>
          <div class="b02 bb" style="justify-content: flex-end">
            <span style="color:  #000">
              {{ item.qian_year_red_score || "-" }}
            </span>
            ({{ item.qian_year_min_score || "-" }})
          </div>
        </div>
        <div class="xian">
          <div class="b01 bb">
            <el-tooltip
              class="item"
              effect="dark"
              content="征集计划数（一次征集/二次征集）"
              placement="top">
              <img src="@/assets/yuce03.png" class="yuce" alt="" />
            </el-tooltip>
            <span style="margin-left: auto; color: #000">
              <span style="color:  #000">
                {{ item.mingnian_one_zhengji || "-" }}
              </span>
              /{{ item.mingnian_two_zhengji || "-" }}
            </span>
          </div>
          <div class="b02 bb" style="justify-content: flex-end; color: #000">
            <span style="color:  #000">{{ item.current_zhengji1 || "-" }}</span>
            /{{ item.current_zhengji2 || "-" }}
          </div>
          <div class="b02 bb" style="justify-content: flex-end; color: #000">
            <span style="color:  #000">{{ item.qu_zhengji1 || "-" }}</span>
            /{{ item.qu_zhengji2 || "-" }}
          </div>
          <div class="b02 bb" style="justify-content: flex-end; color: #000">
            <span style="color:  #000">{{ item.qian_zhengji1 || "-" }}</span>
            /{{ item.qian_zhengji2 || "-" }}
          </div>
        </div>
        <div class="xian">
          <div class="b01 bb">
            <el-tooltip
              class="item"
              effect="dark"
              content="位次"
              placement="top">
              <img src="@/assets/yuce04.png" class="yuce" alt="" />
            </el-tooltip>
            <span
              style="margin-left: auto; color:  #000"
              v-if="form.yugu_zhanshi == 1">
              {{ item.yugu_seat || "-" }}
            </span>
            <span
              style="margin-left: auto; color: #000"
              v-if="form.yugu_zhanshi == 2">
              {{ item.yugu_seat || "-" }}
            </span>
          </div>
          <div class="b02 bb" style="justify-content: flex-end; color: #000">
            {{ item.current_year_min_beat || "--" }}
          </div>
          <div class="b02 bb" style="justify-content: flex-end; color: #000">
            {{ item.qu_year_min_beat || "-" }}
          </div>
          <div class="b02 bb" style="justify-content: flex-end; color: #000">
            {{ item.qian_year_min_beat || "-" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { add, del, updateAll, updateExt } from "@/api/gw/volunteerresult.js";
import Sortable from "sortablejs";
import draggable from "vuedraggable";
import html2canvas from "html2canvas";
import { mapGetters } from "vuex";
export default {
  components: {
    draggable,
  },
  computed: {
    ...mapGetters(["userinfo"]),
  },
  data() {
    return {
      list: [],
    };
  },
  props: {
    activeName: {
      type: String,
      default: "1",
    },
    lists: {
      type: Array,
     defalut: [],
    },
    form: {
      type: Object,
      default: {},
    }
  },
  watch: {},
  mounted() {},
  methods: {
    //跳转专业详情
    majorDetail(item) {
      const routerUrl = this.$router.resolve({
        path: "/MajorDetail?n=" + item.mojor_id,
      });
      window.open(routerUrl.href, "_blank");
    },
    //跳转学校详情
    collegeClick(item) {
      const routerUrl = this.$router.resolve({
        path: "/SchoolDetail?isCha=1&n=" + item.collegiate_id,
      });
      window.open(routerUrl.href, "_blank");
    },
    end(event) {
      // 获取新的顺序
      let list = [...this.list];
      const newOrder = list.map((item, index) => ({
        ...item,
        position: index,
      }));
      let arr = [];
      newOrder.forEach((r, j) => {
        arr.push({
          volunteer_result_id: r.volunteer_result_id,
          sort_id: Number(j + 1),
          // collegeName:r.collegeName,
          // specialty_title:r.specialty_title
        });
      });
      console.log(arr);
      //此时走更新
      updateAll({
        list: arr,
      })
        .then(() => {})
        .catch(() => {
          this.$parent.yichuList();
        });
    },
    // 排序修改方法
    updateExt(row, field) {
      if (row.volunteer_result_id) {
        updateExt({
          volunteer_result_id: row.volunteer_result_id,
          [field]: row[field],
        }).then((res) => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$parent.yichuList();
        });
      }
    },
    //添加
    addClick(item) {
      let that = this;
      let form = {
        volunteer_id: this.$parent.aspid,
        collegeName: item.collegeName,
        specialty_title: item.specialty_title,
      };
      const loading = this.$loading({
        lock: true,
        text: "添加中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      add(form)
        .then(() => {
          this.$message.success("已成功将指定专业添加到志愿列表。");
          this.$parent.yichuList();
        })
        .finally(() => {
          loading.close();
        });
    },
    //移除
    delClick(item) {
      console.log(item);
      if (!item.volunteer_result_id) {
        this.$message.error("移除失败");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "移除中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      del({
        volunteer_result_id: item.volunteer_result_id,
      })
        .then(() => {
          this.$message.success("已成功移除指定专业");
          this.$parent.yichuList();
        })
        .finally(() => {
          loading.close();
        });
    },
    //算法展示
    suanfa(item) {
      //（当年位次/当年总计划*0.5+去年位次/去年总计划数*0.3+前年位次/前年总计划数*0.2）*预测年招生计划数
      let seat = item.mingnian_seat || 0; //当年位次
      let qunian_seat = item.qunian_seat || 0; //去年位次
      let qiannian_seat = item.qiannian_seat || 0; //前年位次
      let dangNum = 0; //当年做计划
      let qunianNum = 0; //去年总计划
      let qianNum = 0; //前年总计划
      let yuceNum = 0; //预测年招生计划

      if (item.batch == "本科批" && item.group_d == "物理科目组合") {
        dangNum = this.form.dangyear_benke_wuli_num || 0;
        qunianNum = this.form.qunian_benke_wuli_num || 0;
        qianNum = this.form.qiannian_benke_wuli_num || 0;
        yuceNum = this.form.yugu_benke_wuli_num || 0;
      }
      if (item.batch == "本科批" && item.group_d == "历史科目组合") {
        dangNum = this.form.dangyear_benke_lishi_num || 0;
        qunianNum = this.form.qunian_benke_lishi_num || 0;
        qianNum = this.form.qiannian_benke_lishi_num || 0;
        yuceNum = this.form.yugu_benke_lishi_num || 0;
      }
      if (item.batch == "专科批" && item.group_d == "物理科目组合") {
        dangNum = this.form.dangyear_zhuanke_wuli_num || 0;
        qunianNum = this.form.qunian_zhuanke_wuli_num || 0;
        qianNum = this.form.qiannian_zhuanke_wuli_num || 0;
        yuceNum = this.form.yugu_zhuanke_wuli_num || 0;
      }
      if (item.batch == "专科批" && item.group_d == "历史科目组合") {
        dangNum = this.form.dangyear_zhuanke_lishi_num || 0;
        qunianNum = this.form.qunian_zhuanke_lishi_num || 0;
        qianNum = this.form.qiannian_zhuanke_lishi_num || 0;
        yuceNum = this.form.yugu_zhuanke_lishi_num || 0;
      }
      let num =
        ((seat / dangNum) * 0.5 +
          (qunian_seat / qunianNum) * 0.3 +
          (qiannian_seat / qianNum) * 0.2) *
        yuceNum;
      return parseInt(num);
    },
    //检测专业是A+还是其他
    majorReturn(item) {
      if (item.ajia_major && item.ajia_major.includes(item.majors)) {
        return "A+";
      } else if (item.as_major && item.as_major.includes(item.majors)) {
        return "A";
      } else if (item.a_jian_major && item.a_jian_major.includes(item.majors)) {
        return "A-";
      } else if (item.b_jia_major && item.b_jia_major.includes(item.majors)) {
        return "B+";
      } else if (item.b_majors && item.b_majors.includes(item.majors)) {
        return "B";
      } else if (item.b_jian_major && item.b_jian_major.includes(item.majors)) {
        return "B-";
      } else if (item.c_jia_major && item.c_jia_major.includes(item.majors)) {
        return "C+";
      } else if (item.c_major && item.c_major.includes(item.majors)) {
        return "C";
      } else if (item.c_jian_major && item.c_jian_major.includes(item.majors)) {
        return "C-";
      } else {
        return "无";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/framework.scss';
.color000{
  color: #000!important;
}
.bgn {
  background: none;
  color: #000;
}

.table {
  width: 100%;

  .tables {
    width: 100%;
    display: flex;
    background-color: #fff;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .tables:nth-child(2n) {
    background: #f5fbff !important;
  }
}

.back002 {
  .biaotous,
  .biaotou01,
  .bb {
    background: #716aca !important;
  }
}

.back003 {
  .biaotous,
  .biaotou01,
  .bb {
    background: lightslategrey !important;
  }
}

.back004 {
  .biaotous,
  .biaotou01,
  .bb {
    background: #ffa534 !important;
  }
}

.biaotou {
  width: 100%;
  height: 60px;
  margin-top: 5px;
  display: flex;

  .row {
    display: flex;
    flex-wrap: wrap;
  }
}

.h-100 {
  height: 100%;
}

.zhineng {
  background: #716aca !important;
  background-color: #716aca !important;
  border: 1px solid #716aca !important;
  margin-left: 60px;
}

.block {
  display: flex;
  align-items: center;
  margin-left: 30px;

  .demonstration {
    font-weight: bold;
    font-size: 12px;
  }

  .el-slider {
    width: 180px !important;
    margin-left: 10px;
  }

  .el-slider__bar {
    background-color: #ed5565 !important;
  }
}

.active {
  width: 100%;
  display: flex;
  align-items: center;
}

.header {
  width: 100%;
  display: flex;
  align-items: center;

  .header01 {
    display: flex;
    align-items: flex-end;
    font-size: 20px;

    span {
      font-size: 14px;
      margin-left: 20px;
    }
  }
}

.con {
  width: 100%;
  height: 100vh;
  background: #eee !important;

  .cons {
    width: 100%;
    margin: 0 auto;
    height: 200px;
    position: fixed;
    z-index: 1030;
    left: 0px;
    top: 0px;
    background: #eee !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/volunteer/components/tables.vue